export default {
  review: {
    title: 'Reviews',
    seeAll: 'Read all reviews',
    heading: {
      title: 'Really great that you like to provide feedback!',
      description: 'Your feedback will help your teacher and host a lot.',
    },
    rating: {
      title: 'Would you rate your experience 5 stars?',
    },
    review: {
      title: 'Tell us more about your experience.',
      placeholder:
        'Who would you recommened this class to? What did you like most?',
    },
    legalCopy:
      'By submitting your review, you agree to our {termsAndConditions}.',
    termsAndConditions: 'Terms & Conditions',
    notification: {
      success: {
        title: 'You reviewed the event',
        description:
          'As a small thank you for your feedback you get 15 € discount with the code KONBACK15. Minimum order value 50€.',
      },
      error: {
        title: 'An error has occurred',
        description:
          'If you already reviewed this event, you cannot review it again. If not, please try again',
      },
    },
    form: {
      title: 'How was your {category}',
      starsLabel: 'Rate your experience',
      starsError: 'Please provide your rating',
      textareaLabel: 'Tell us what you think',
      textareaPlaceholder:
        'How was the package, shipping, and overall experience?',
      textareaText: 'Your review title: "{n}..."',
      textareaError: 'Please enter the text of the review',
      uploadLabel: 'Upload photos or videos of your {category}',
      uploadText: 'You can upload up to {max} files',
      submitButton: 'Submit your review',
      successTitle: 'Thanks for your review!',
      successText: 'Here’s a discount for your next experience:',
      copyCode: 'Copy discount code',
      copyCodeSuccess: 'Copied',
      backButton: 'Go to konfetti',

      course: {
        title: 'How was your course?',
        starsLabel: 'Rate your course',
        textareaLabel: 'Tell us what you think',
        textareaPlaceholder:
          'How were the instructor, the material, and your overall experience?',
      },

      tour: {
        title: 'How was your tour?',
        starsLabel: 'Rate the tour',
        textareaLabel: 'Tell us what you think',
        textareaPlaceholder:
          'How were the tour itinerary, guide, and overall experience?',
      },

      experience: {
        title: 'How was your experience?',
        starsLabel: 'Rate the experience',
        textareaLabel: 'Tell us what you think',
        textareaPlaceholder:
          'How were the activity, the instructor and the location?',
      },

      kit: {
        title: 'How was your kit?',
        starsLabel: 'Rate the kit',
        textareaLabel: 'Tell us what you think',
        textareaPlaceholder:
          'How were the content, the package, the shipping and your overall experience?',
      },
    },
  },
}
